'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n'
  ],
  [
    '\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n'
  ]
)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Truncate = _Text2.default.extend(_templateObject)

Truncate.displayName = 'Truncate'

exports.default = Truncate



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Truncate.js
// module id = 523
// module chunks = 168707334958949